// Block > Block
import React from 'react'
import styled from 'styled-components'
import classNames from 'classnames'
import { BlockProps, BlockState } from './index'
import styles from './Block.module.css'
import '../global.css'

export const defaultProps = Object.freeze({
	isGroupScale: false,
	disabled: false,
	color: 'blue',
	numCollisions: 0,
	width: 100
})

export class Block extends React.PureComponent<BlockProps, BlockState> {
	public static defaultProps = defaultProps

	constructor(props: BlockProps) {
		super(props)
		const { start, end, scale } = props
		const calcedStart = start !== null && start !== undefined ? start : 0

		this.state = {
			start: calcedStart,
			end: end !== null && end !== undefined ? end : calcedStart + scale.increment
		}

		if (this.state.end <= this.state.start) throw new Error('end must be greater than start')
		if (scale.max < scale.min) throw new Error("scale max can't be less than scale min")
	}

	componentDidUpdate() {
		const { start, end, scale } = this.props
		const calcedStart = start !== null && start !== undefined ? start : 0

		this.setState({
			start: calcedStart,
			end: end !== null && end !== undefined ? end : calcedStart + scale.increment
		})
	}

	/**
	 * getters
	 */

	heightPercent = (): number => {
		const { start, end } = this.state
		const { scale } = this.props

		if (start == scale.min && end == scale.max) return 100

		return (end - start) / scale.totalIncrements * 100
	}

	topPercent = (): number => {
		const { start } = this.state
		const { scale, isGroupScale } = this.props

		let shiftedStart = start // start = 0, scale.min = -2
		// let shiftedEnd = end
		if (!isGroupScale && scale.min < 0) {
			shiftedStart += Math.abs(scale.min)
			// shiftedEnd += Math.abs(scale.min)
		}

		return shiftedStart / scale.totalIncrements * 100
	}

	calcHeight = (): string => {
		let height: string = `${this.heightPercent()}%`

		return height
	}

	calcTop = (): string => {
		const height: string = `calc(${this.topPercent()}%)`

		return height
	}

	// *****
	// end getters
	// *****

	// *****
	// UX
	// *****

	/**
	 * passes the block's index value to the handleMouseDown prop
	 */
	_handleMouseDown = (event: React.MouseEvent<HTMLDivElement>): void => {
		// don't bubble to parents
		event.stopPropagation()

		const { index, handleMouseDown, disabled } = this.props

		if (!disabled && handleMouseDown) {
			if (index === undefined || index === null) {
				console.warn('Block is missing identifier')
				return
			}

			handleMouseDown(index, event.altKey)
		}
	}

	/**
	 * passes the block's index value to the hanldeMouseEnter prop
	 */
	_handleMouseEnter = (): void => {
		const { disabled, index, handleMouseEnter } = this.props

		if (!disabled && handleMouseEnter) {
			if (index === undefined || index === null) {
				console.warn('Block is missing identifier')
				return
			}

			handleMouseEnter(index)
		}
	}

	/**
	 * passes the block's index value to the handleMouseUp prop
	 */
	_handleMouseUp = (event: React.MouseEvent<HTMLDivElement>): void => {
		// don't bubble to parents
		event.stopPropagation()

		const { disabled, index, handleMouseUp } = this.props

		if (!disabled && handleMouseUp) {
			if (index === undefined || index === null) {
				console.warn('Block is missing identifier')
				return
			}

			handleMouseUp(event.altKey)
		}
	}

	// *****
	// end UX
	// *****

	render() {
		const { disabled, className, handleMouseDown, handleMouseUp, children } = this.props

		return (
			<div
				className={classNames(styles['block-root'], className, {
					[styles['block-active']]: !disabled && (handleMouseDown || handleMouseUp)
				})}
				style={{
					top: this.calcTop(),
					height: this.calcHeight()
				}}
				onMouseDown={this._handleMouseDown}
				onMouseUp={this._handleMouseUp}
				onMouseEnter={this._handleMouseEnter}
			>
				{children}
			</div>
		)
	}
}

export default styled(Block)`
	position: relative;
	min-height: 20px;
	width: 100%;
	cursor: ${({ disabled, handleMouseDown, handleMouseUp }) =>
		!disabled && (handleMouseDown || handleMouseUp) ? 'pointer' : 'default'};
	${({ color }) => (color ? `background-color: ${color}` : '')};
`
